import React, { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import { motion, AnimatePresence } from "motion/react"
import AddIcon from '@mui/icons-material/Add'
import { Modal } from 'react-bootstrap';
import Select from "react-select"
import { Divider, Steps, Segmented, Flex } from 'antd';
import axios from 'axios';
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

import { v4 as uuidv4 } from "uuid"
import dayjs from 'dayjs';

function TAR({ serverURL, user, setShowSideOverlay, socket, logToUse, setLogToUse }) {
    const [allRules, setAllRules] = useState(null)

    const [conditionType, setConditionType] = useState(null)
    const [subConditionType, setSubConditionType] = useState(null)
    const [showAddRule, setShowAddRule] = useState(false)
    const [matchType, setMatchType] = useState({ label: "Exact Match", value: "exact-match" })
    const [userOptions, setUserOptions] = useState([])

    const [logicalSetToAll, setLogicalSetToAll] = useState("OR")

    const [selectedUser, setSelectedUser] = useState(null)

    const [selectedActionType, setSelectedActionType] = useState(null)

    const [ticketStatusAction, setTicketStatusAction] = useState(null)
    const [ticketPriorityAction, setTicketPriorityAction] = useState(null)

    const [selectedUserAction, setSelectedUserAction] = useState(null)

    const [firstConditionType, setFirstConditionType] = useState("tickets")

    const getAllDepartments = async () => {
        const getDisticsDepartment = await axios.post(serverURL + "/forms/getAnimals")
        if (getDisticsDepartment.status === 200) {
            let userListings = []

            getDisticsDepartment.data.users.map((userData, key) => {
                return userListings.push({ "label": userData.submittedData["Employee Name"] + " (" + userData.submittedData["Process / Department"] + ")", "value": userData.submittedData["Official Mail Id"], "department": userData.submittedData["Process / Department"], "subDepartment": userData.submittedData["Sub Department"], "otherData": userData.submittedData })
            })

            // console.log(userListings)

            setUserOptions(userListings)


        } else {
            console.log(getDisticsDepartment.data)
        }
    }

    const addNewCondition = (e, frame, item) => {
        e.preventDefault();
        console.log(frame, item);
        //    const element= document.createElement
        let itemlength = document.querySelectorAll(`.${item}Item`);

        let lastId = itemlength[itemlength.length - 1].getAttribute("id").split("_")[1]

        let currentCount = parseInt(lastId) + 1

        console.log(currentCount)

        // "condition_type_0"
        // "condition_rule_0"
        // "condition_logic_0"
        // "condition_value_0"

        let superParent = document.querySelector(`#${frame}`)

        let udaDeButton = document.createElement("button")
        udaDeButton.innerHTML = "X"
        udaDeButton.type = "button"
        udaDeButton.classList = "btn btn-sm btn-danger p-1 rounded-circle"
        udaDeButton.style = "position:absolute;top:0;right:0;transform:translateX(150%);height:30px;aspect-ratio: 1;"

        let mainFrame = document.createElement("div")
        mainFrame.classList = `alert alert-secondary shadow-sm d-flex flex-column gap-3 w-100 m-0 ${item}Item`
        mainFrame.id = `${item}_${currentCount}`

        let innerFrame = document.createElement("div")
        innerFrame.classList = "w-100 d-flex gap-3 flex-wrap flex-lg-nowrap"

        let innerInput = document.createElement("input")
        innerInput.type = "text"
        innerInput.id = `${item}_input_${currentCount}`
        innerInput.classList = `w-100 form-control condition_value_${currentCount}`
        innerInput.placeholder = `${item} Value`

        let innerSelect1 = document.createElement("select")
        innerSelect1.classList = `form-control condition_type_${currentCount}`
        innerSelect1.required = true
        innerSelect1.id = `${item}_select_mainCategory_${currentCount}`

        let innerSelect2 = document.createElement("select")
        innerSelect2.classList = `form-control condition_rule_${currentCount}`
        innerSelect2.required = true
        innerSelect2.id = `${item}_select_subCategory_${currentCount}`

        let innerSelect3 = document.createElement("select")
        innerSelect3.classList = `form-control condition_logic_${currentCount}`
        innerSelect3.required = true
        innerSelect3.id = `${item}_select_match_${currentCount}`

        let select1Option1 = document.createElement("option")
        let select1Option2 = document.createElement("option")
        let select1Option3 = document.createElement("option")

        let select1Option1textNod = document.createTextNode("Students")
        let select1Option2textNod = document.createTextNode("Tickets")
        let select1Option3textNod = document.createTextNode("YG Mail")

        select1Option1.appendChild(select1Option1textNod)
        select1Option2.appendChild(select1Option2textNod)
        select1Option3.appendChild(select1Option3textNod)

        select1Option1.value = select1Option1textNod.textContent.replaceAll(" ", "-").toLowerCase()
        select1Option2.value = select1Option2textNod.textContent.replaceAll(" ", "-").toLowerCase()
        select1Option3.value = select1Option3textNod.textContent.replaceAll(" ", "-").toLowerCase()

        let select3Option1 = document.createElement("option")
        let select3Option2 = document.createElement("option")
        let select3Option3 = document.createElement("option")
        let select3Option4 = document.createElement("option")
        let select3Option5 = document.createElement("option")

        let select3Option1textNod = document.createTextNode("Contains")
        let select3Option2textNod = document.createTextNode("Not Contains")
        let select3Option3textNod = document.createTextNode("Exact Match")
        let select3Option4textNod = document.createTextNode("In")
        let select3Option5textNod = document.createTextNode("Not In")

        select3Option1.appendChild(select3Option1textNod)
        select3Option2.appendChild(select3Option2textNod)
        select3Option3.appendChild(select3Option3textNod)
        select3Option4.appendChild(select3Option4textNod)
        select3Option5.appendChild(select3Option5textNod)

        select3Option1.value = select3Option1textNod.textContent.replaceAll(" ", "-").toLowerCase()
        select3Option2.value = select3Option2textNod.textContent.replaceAll(" ", "-").toLowerCase()
        select3Option3.value = select3Option3textNod.textContent.replaceAll(" ", "-").toLowerCase()
        select3Option4.value = select3Option4textNod.textContent.replaceAll(" ", "-").toLowerCase()
        select3Option5.value = select3Option5textNod.textContent.replaceAll(" ", "-").toLowerCase()

        let studentSelectOptionNone = document.createElement("option")
        let studentSelectOption1 = document.createElement("option")
        let studentSelectOption2 = document.createElement("option")
        let studentSelectOption3 = document.createElement("option")
        let studentSelectOption4 = document.createElement("option")

        let ticketSelectOptionNone = document.createElement("option")
        let ticketSelectOption1 = document.createElement("option")
        let ticketSelectOption2 = document.createElement("option")
        let ticketSelectOption3 = document.createElement("option")

        let ygMailSelectOptionNone = document.createElement("option")
        let ygMailSelectOption1 = document.createElement("option")
        let ygMailSelectOption2 = document.createElement("option")
        let ygMailSelectOption3 = document.createElement("option")
        let ygMailSelectOption4 = document.createElement("option")

        let studentSelectOptionNoneTextNode = document.createTextNode("-- Select one --")
        let studentSelectOption1TextNode = document.createTextNode("Intake")
        let studentSelectOption2TextNode = document.createTextNode("branch")
        let studentSelectOption3TextNode = document.createTextNode("Student Email Id")
        let studentSelectOption4TextNode = document.createTextNode("Student YG Id(s)")

        let ticketSelectOptionNoneTextNode = document.createTextNode("-- Select one --")
        let ticketSelectOption1TextNode = document.createTextNode("Created By")
        let ticketSelectOption2TextNode = document.createTextNode("Raised By")
        let ticketSelectOption3TextNode = document.createTextNode("Subject")

        let ygMailSelectOptionNoneTextNode = document.createTextNode("-- Select one --")
        let ygMailSelectOption1TextNode = document.createTextNode("Intake")
        let ygMailSelectOption2TextNode = document.createTextNode("Branch")
        let ygMailSelectOption3TextNode = document.createTextNode("Student YG Id")
        let ygMailSelectOption4TextNode = document.createTextNode("Subject")

        let devider = document.createElement("div")
        devider.innerHTML = `<div class='andOrSwitches px-3 py-1 rounded-pill shadow-sm fw-bold customeButtonGradient'>${logicalSetToAll}</div>`
        devider.classList = "w-100 d-flex justify-content-center align-items-center"

        devider.style = "transform:translateY(0%);z-index:9999;"

        udaDeButton.addEventListener("click", () => {
            superParent.removeChild(devider)
            superParent.removeChild(mainFrame)
        })

        studentSelectOptionNone.appendChild(studentSelectOptionNoneTextNode)
        studentSelectOption1.appendChild(studentSelectOption1TextNode)
        studentSelectOption2.appendChild(studentSelectOption2TextNode)
        studentSelectOption3.appendChild(studentSelectOption3TextNode)
        studentSelectOption4.appendChild(studentSelectOption4TextNode)

        ticketSelectOptionNone.appendChild(ticketSelectOptionNoneTextNode)
        ticketSelectOption1.appendChild(ticketSelectOption1TextNode)
        ticketSelectOption2.appendChild(ticketSelectOption2TextNode)
        ticketSelectOption3.appendChild(ticketSelectOption3TextNode)

        ygMailSelectOptionNone.appendChild(ygMailSelectOptionNoneTextNode)
        ygMailSelectOption1.appendChild(ygMailSelectOption1TextNode)
        ygMailSelectOption2.appendChild(ygMailSelectOption2TextNode)
        ygMailSelectOption3.appendChild(ygMailSelectOption3TextNode)
        ygMailSelectOption4.appendChild(ygMailSelectOption4TextNode)

        studentSelectOption1.value = studentSelectOption1TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        studentSelectOption2.value = studentSelectOption2TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        studentSelectOption3.value = studentSelectOption3TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        studentSelectOption4.value = studentSelectOption4TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ticketSelectOption1.value = ticketSelectOption1TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ticketSelectOption2.value = ticketSelectOption2TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ticketSelectOption3.value = ticketSelectOption3TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ygMailSelectOption1.value = ygMailSelectOption1TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ygMailSelectOption2.value = ygMailSelectOption2TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ygMailSelectOption3.value = ygMailSelectOption3TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        ygMailSelectOption4.value = ygMailSelectOption4TextNode.textContent.replaceAll(" ", "-").toLowerCase()

        studentSelectOptionNone.value = ""
        ticketSelectOptionNone.value = ""
        ygMailSelectOptionNone.value = ""

        studentSelectOptionNone.disabled = true
        ticketSelectOptionNone.disabled = true
        ygMailSelectOptionNone.disabled = true

        studentSelectOptionNone.selected = true
        ticketSelectOptionNone.selected = true
        ygMailSelectOptionNone.selected = true


        innerSelect1.appendChild(select1Option1)
        innerSelect1.appendChild(select1Option2)
        innerSelect1.appendChild(select1Option3)

        innerSelect2.appendChild(studentSelectOptionNone)
        innerSelect2.appendChild(studentSelectOption1)
        innerSelect2.appendChild(studentSelectOption2)
        innerSelect2.appendChild(studentSelectOption3)
        innerSelect2.appendChild(studentSelectOption4)


        innerSelect1.addEventListener("change", (e) => {


            console.log(e.target.value)
            if (e.target.value === "students") {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }

                innerSelect2.appendChild(studentSelectOptionNone)
                innerSelect2.appendChild(studentSelectOption1)
                innerSelect2.appendChild(studentSelectOption2)
                innerSelect2.appendChild(studentSelectOption3)
                innerSelect2.appendChild(studentSelectOption4)

            }
            else if (e.target.value === "tickets") {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }
                innerSelect2.appendChild(ticketSelectOptionNone)
                innerSelect2.appendChild(ticketSelectOption1)
                innerSelect2.appendChild(ticketSelectOption2)
                innerSelect2.appendChild(ticketSelectOption3)
            }
            else if (e.target.value === "yg-mail") {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }

                innerSelect2.appendChild(ygMailSelectOptionNone)
                innerSelect2.appendChild(ygMailSelectOption1)
                innerSelect2.appendChild(ygMailSelectOption2)
                innerSelect2.appendChild(ygMailSelectOption3)
                innerSelect2.appendChild(ygMailSelectOption4)


            }
            else {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }

                innerSelect2.appendChild(studentSelectOptionNone)
                innerSelect2.appendChild(studentSelectOption1)
                innerSelect2.appendChild(studentSelectOption2)
                innerSelect2.appendChild(studentSelectOption3)
                innerSelect2.appendChild(studentSelectOption4)
            }
        })

        innerSelect3.appendChild(select3Option1)
        innerSelect3.appendChild(select3Option2)
        innerSelect3.appendChild(select3Option3)
        innerSelect3.appendChild(select3Option4)
        innerSelect3.appendChild(select3Option5)

        innerFrame.appendChild(innerSelect1)
        innerFrame.appendChild(innerSelect2)
        innerFrame.appendChild(innerSelect3)

        mainFrame.appendChild(innerFrame)
        mainFrame.appendChild(innerInput)
        mainFrame.appendChild(udaDeButton)


        if (item !== "action") {
            superParent.appendChild(devider)
        }
        superParent.appendChild(mainFrame)

    }

    const changeTheLogicalValues = (e) => {
        setLogicalSetToAll(e)
        let allBeems = document.getElementsByClassName("andOrSwitches")
        for (let i = 0; i < allBeems.length; i++) {
            allBeems[i].innerHTML = e === "AND" ? "AND" : "OR"
        }
    }

    const addNewAction = (e, frame, item) => {
        e.preventDefault();
        console.log(frame, item);
        //    const element= document.createElement
        let itemlength = document.querySelectorAll(`.${item}Item`);

        let lastId = itemlength[itemlength.length - 1].getAttribute("id").split("_")[1]

        let currentCount = parseInt(lastId) + 1

        // console.log(currentCount)

        let superParent = document.querySelector(`#${frame}`)

        let udaDeButton = document.createElement("button")
        udaDeButton.innerHTML = "X"
        udaDeButton.type = "button"
        udaDeButton.classList = "btn btn-sm btn-danger p-1 rounded-circle"
        udaDeButton.style = "position:absolute;top:0;right:0;transform:translateX(150%);height:30px;aspect-ratio: 1;"

        let mainFrame = document.createElement("div")

        mainFrame.classList = `alert alert-secondary shadow-sm d-flex flex-column gap-3 w-100 m-0 ${item}Item`

        mainFrame.id = `${item}_${currentCount}`

        let innerFrame = document.createElement("div")
        innerFrame.classList = "w-100 d-flex gap-3 flex-wrap flex-lg-nowrap"

        let innerSelect1 = document.createElement("select")
        innerSelect1.classList = `form-control ${item}_select_mainCategory_${currentCount}`
        innerSelect1.id = `${item}_select_mainCategory_${currentCount}`
        innerSelect1.required = true

        let innerSelect2 = document.createElement("select")
        innerSelect2.classList = `form-control ${item}_select_subCategory_${currentCount}`
        innerSelect2.id = `${item}_select_subCategory_${currentCount}`
        innerSelect2.required = true




        let firstSelectOptionNonTextNode = document.createTextNode("-- Select one --")
        let firstSelectOptionTextNode1 = document.createTextNode("Ticket Status")
        let firstSelectOptionTextNode2 = document.createTextNode("Ticket Assigned To")
        let firstSelectOptionTextNode3 = document.createTextNode("Ticket Priority As")

        let innerSelectOptionNone = document.createElement("option")
        let innerSelectOption1 = document.createElement("option")
        let innerSelectOption2 = document.createElement("option")
        let innerSelectOption3 = document.createElement("option")

        innerSelectOptionNone.appendChild(firstSelectOptionNonTextNode)
        innerSelectOption1.appendChild(firstSelectOptionTextNode1)
        innerSelectOption2.appendChild(firstSelectOptionTextNode2)
        innerSelectOption3.appendChild(firstSelectOptionTextNode3)

        innerSelectOptionNone.value = ""
        innerSelectOption1.value = firstSelectOptionTextNode1.textContent.replaceAll(" ", "-").toLowerCase()
        innerSelectOption2.value = firstSelectOptionTextNode2.textContent.replaceAll(" ", "-").toLowerCase()
        innerSelectOption3.value = firstSelectOptionTextNode3.textContent.replaceAll(" ", "-").toLowerCase()

        innerSelect1.appendChild(innerSelectOptionNone)
        innerSelect1.appendChild(innerSelectOption1)
        innerSelect1.appendChild(innerSelectOption2)
        innerSelect1.appendChild(innerSelectOption3)

        let statusOptionNon = document.createElement("option")
        let statusOption1 = document.createElement("option")
        let statusOption2 = document.createElement("option")
        let statusOption3 = document.createElement("option")
        let statusOption4 = document.createElement("option")

        let statusOptionNonTextNode = document.createTextNode("-- Select one --")
        let statusOption1TextNode = document.createTextNode("Open")
        let statusOption2TextNode = document.createTextNode("Closed")
        let statusOption3TextNode = document.createTextNode("In-Process")
        let statusOption4TextNode = document.createTextNode("Re-Open")

        statusOptionNon.value = ""
        statusOption1.value = statusOption1TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        statusOption2.value = statusOption2TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        statusOption3.value = statusOption3TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        statusOption4.value = statusOption4TextNode.textContent.replaceAll(" ", "-").toLowerCase()

        statusOptionNon.appendChild(statusOptionNonTextNode)
        statusOption1.appendChild(statusOption1TextNode)
        statusOption2.appendChild(statusOption2TextNode)
        statusOption3.appendChild(statusOption3TextNode)
        statusOption4.appendChild(statusOption4TextNode)

        let priorityOptionNon = document.createElement("option")
        let priorityOption1 = document.createElement("option")
        let priorityOption2 = document.createElement("option")
        let priorityOption3 = document.createElement("option")

        let priorityOptionNonTextNode = document.createTextNode("-- Select one --")
        let priorityOption1TextNode = document.createTextNode("Low")
        let priorityOption2TextNode = document.createTextNode("Medium")
        let priorityOption3TextNode = document.createTextNode("High")

        priorityOptionNon.value = ""
        priorityOption1.value = priorityOption1TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        priorityOption2.value = priorityOption2TextNode.textContent.replaceAll(" ", "-").toLowerCase()
        priorityOption3.value = priorityOption3TextNode.textContent.replaceAll(" ", "-").toLowerCase()

        priorityOptionNon.appendChild(priorityOptionNonTextNode)
        priorityOption1.appendChild(priorityOption1TextNode)
        priorityOption2.appendChild(priorityOption2TextNode)
        priorityOption3.appendChild(priorityOption3TextNode)

        udaDeButton.addEventListener("click", () => {
            superParent.removeChild(mainFrame)
        })







        userOptions.map((user, key) => {
            let userOption = document.createElement("option")
            userOption.value = user.value
            userOption.textContent = user.label
            innerSelect2.appendChild(userOption)
        })




        innerSelect1.addEventListener("change", (e) => {


            console.log(e.target.value)
            if (e.target.value === "ticket-status") {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }

                innerSelect2.appendChild(statusOptionNon)
                innerSelect2.appendChild(statusOption1)
                innerSelect2.appendChild(statusOption2)
                innerSelect2.appendChild(statusOption3)
                innerSelect2.appendChild(statusOption4)

            }
            else if (e.target.value === "ticket-assigned-to") {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }

                userOptions.map((user, key) => {
                    let userOption = document.createElement("option")
                    userOption.value = user.value
                    userOption.textContent = user.label
                    innerSelect2.appendChild(userOption)
                })
            }
            else if (e.target.value === "ticket-priority-as") {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }

                innerSelect2.appendChild(priorityOptionNon)
                innerSelect2.appendChild(priorityOption1)
                innerSelect2.appendChild(priorityOption2)
                innerSelect2.appendChild(priorityOption3)


            }
            else {

                while (innerSelect2.firstChild) {
                    // The list is LIVE so it will re-index each call
                    innerSelect2.removeChild(innerSelect2.firstChild);
                }
                innerSelect2.appendChild(priorityOptionNon)
                innerSelect2.appendChild(priorityOption1)
                innerSelect2.appendChild(priorityOption2)
                innerSelect2.appendChild(priorityOption3)
            }
        })




        innerFrame.appendChild(innerSelect1)
        innerFrame.appendChild(innerSelect2)

        mainFrame.appendChild(innerFrame)
        mainFrame.appendChild(udaDeButton)

        superParent.appendChild(mainFrame)
    }



    const saveRule = async () => {
        const getAllConditions = document.getElementsByClassName("conditionItem")
        const getAllActions = document.getElementsByClassName("actionItem")


        console.log(getAllActions.length, getAllConditions.length)

        let allActionsCollector = []
        let allConditionsCollector = []

        for (let i = 0; i < getAllActions.length; i++) {

            const actionType = document.getElementsByClassName(`action_select_mainCategory_${i}`)
            const actionValue = document.getElementsByClassName(`action_select_subCategory_${i}`)

            allActionsCollector.push({
                [`${actionType[0].value}`]: actionValue[0].value
            })
        }

        for (let j = 0; j < getAllConditions.length; j++) {

            const conditionType = document.getElementsByClassName(`condition_type_${j}`)
            const conditionRule = document.getElementsByClassName(`condition_rule_${j}`)
            const conditionLogic = document.getElementsByClassName(`condition_logic_${j}`)
            const conditionValue = document.getElementsByClassName(`condition_value_${j}`)

            allConditionsCollector.push({
                "type": conditionType[0].value,
                "rule": conditionRule[0].value,
                "logic": conditionLogic[0].value,
                "value": conditionValue[0].value,
            })
        }

        const automationName = document.getElementById("automationName")

        const finalQueryForAutomationData = {
            "uid": uuidv4(),
            "name": automationName.value,
            "conditions": allConditionsCollector,
            "actions": allActionsCollector,
            "conditionLogic": logicalSetToAll,
            "status": true
        }



        const saveTarFilters = await axios.post(serverURL + "/tar/saveNewRule", finalQueryForAutomationData)

        if (saveTarFilters.status === 200) {
            console.log(saveTarFilters.data)

            setAllRules([...allRules, saveTarFilters.data])
            setShowAddRule(false)
        } else {
            console.log(saveTarFilters.data)
        }
    }


    const getAllRules = async () => {
        const getAllRulesNow = await axios.post(serverURL + "/tar/getAllRules")
        if (getAllRulesNow.status === 200) {
            console.log(getAllRulesNow.data)
            setAllRules(getAllRulesNow.data)
        } else {
            console.log(getAllRulesNow.data)
        }
    }

    const deleteThisRule = async (uid) => {
        const deteleThisRuleNow = await axios.post(serverURL + "/tar/deleteRule", { id: uid })
        if (deteleThisRuleNow.status === 200) {
            console.log(deteleThisRuleNow.data)

            setAllRules(allRules.filter((rule) => { return rule.uid !== uid }))
        } else {
            console.log(deteleThisRuleNow.data)
        }
    }

    useEffect(() => {
        getAllDepartments()
        getAllRules()
    }, [])
    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Ticket Automation Rule</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='d-flex gap-2 justify-content-between align-items-streach px-3 py-1 w-100'>
                    <AnimatePresence>
                        {
                            !logToUse &&
                            <motion.button
                                initial={{ scale: 0, rotateZ: 90 }}
                                animate={{ scale: 1, rotateZ: 0 }}
                                exit={{ scale: 0, rotateZ: 90 }}
                                transition={{ duration: .5, delay: 0 }}
                                title='Add Ticket' className={`btn btn-sm rounded-pill ${showAddRule ? "btn-outline-danger" : "btn-outline-secondary"} d-flex align-items-center p-1`} style={{ aspectRatio: "1/1" }} onClick={() => { setShowAddRule(!showAddRule); }}>
                                <AddIcon style={showAddRule ? { aspectRatio: "1/1", transform: "rotateZ(45deg)", transition: ".3s ease-in-out" } : { aspectRatio: "1/1", transform: "rotateZ(0deg)", transition: ".3s ease-in-out" }} />
                            </motion.button>
                        }
                    </AnimatePresence>
                </div>
                <div className={`w-100 h-100 overflow-auto d-flex flex-column gap-2`}>
                    {
                        allRules?.length > 0 ?
                            <table className='table table-bordered'>
                                <thead className='table-success'>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Created On</th>
                                        <th>Last Update</th>
                                        <th>Condition</th>
                                        <th>Actions</th>
                                        <th>Should all match</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {

                                        allRules.map((rule, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>{key + 1}</td>
                                                    <td>{rule.name}</td>
                                                    <td>{dayjs(rule.createdAt).format("DD MMMM YYYY, h:mma")}</td>
                                                    <td>{dayjs(rule.updatedAt).format("DD MMMM YYYY, h:mma")}</td>
                                                    <td>
                                                        <div className='d-flex flex-column gap-1'>
                                                            {rule.conditions.map((data, key) => {
                                                                return (
                                                                    <div key={key} className='d-flex flex-wrap gap-1 m-0 p-1'>
                                                                        <button className='btn btn-sm btn-dark px-2 py-1'>
                                                                            <span className='fw-bold'>Type</span> : {data.type}
                                                                        </button>
                                                                        <button className='btn btn-sm btn-dark px-2 py-1'>
                                                                            <span className='fw-bold'>Rule</span> : {data.rule}
                                                                        </button>
                                                                        <button className='btn btn-sm btn-dark px-2 py-1'>
                                                                            <span className='fw-bold'>Logic</span> : {data.logic}
                                                                        </button>
                                                                        <button className='btn btn-sm btn-dark px-2 py-1'>
                                                                            <span className='fw-bold'>Value</span> : {data.value}
                                                                        </button>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex flex-column gap-1'>
                                                            {rule.actions.map((data, key) => {
                                                                return (
                                                                    <div key={key} className='d-flex flex-wrap gap-1 m-0 p-1'>
                                                                        <button className='btn btn-sm btn-success px-2 py-1'>
                                                                            <span className='fw-bold'>{Object.keys(data)[0].split("-").join(" ")}</span> : {data[Object.keys(data)[0]]}
                                                                        </button>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </td>
                                                    <td>{rule.conditionLogic === "OR" ? "No" : "Yes"}</td>
                                                    <td>{rule.status ? "Active" : "Inactive"}</td>
                                                    <td width="1%">
                                                        <button onClick={(e) => { deleteThisRule(rule.uid) }} className='btn'>
                                                            <i className='fa fa-trash text-danger fs-5'></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="alert alert-secondary w-100 text-center">No Records for now</div>
                    }

                </div>
            </div>

            <Modal
                centered
                show={showAddRule}
                size='xl'
                backdrop="static"
                onHide={() => { setShowAddRule(false) }}>
                <Modal.Header closeButton closeVariant='light'>
                    <Modal.Title className='fs-5'>Create New Rule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex flex-column gap-3'>
                        <input type="text" required className='w-100 form-control' id="automationName" placeholder='Automation Name *' />
                        <Steps
                            progressDot
                            current={1}
                            direction="vertical"
                            items={[
                                {
                                    title: 'Condition',
                                    description:
                                        <form className='d-flex flex-column align-items-start w-100' style={{ paddingRight: "20px", position: "relative" }} onSubmit={(e) => { addNewCondition(e, "conditionFrame", "condition") }}>
                                            <div className='w-100 d-flex gap-3 justify-content-center align-items-center flex-wrap mb-3' >
                                                {/* <span>On tickets with these properties:</span> */}
                                                <Segmented
                                                    size="medium"
                                                    shape="round"
                                                    className='p-1 shadow-sm customeButtonGradient'
                                                    onChange={(e) => { changeTheLogicalValues(e) }}
                                                    options={[
                                                        { value: 'OR', icon: "Matches ANY of the below", className: "p-1 d-flex align-items-center fw-bold" },
                                                        { value: 'AND', icon: "Matches ALL of the below", className: "p-1 d-flex align-items-center fw-bold" },
                                                    ]}
                                                />
                                            </div>
                                            <div className='d-flex flex-column align-items-start gap-2 w-100' id="conditionFrame">
                                                <div className='alert alert-secondary shadow-sm d-flex flex-column gap-3 w-100 m-0 conditionItem' id='condition_0'>
                                                    <div className='w-100 d-flex gap-3  flex-wrap flex-lg-nowrap'>
                                                        <select className='form-control condition_type_0' required onChange={(e) => {
                                                            if (e.target.value === "tickets") {
                                                                setFirstConditionType("tickets")
                                                            }
                                                            else if (e.target.value === "students") {
                                                                setFirstConditionType("students")
                                                            }
                                                            else if (e.target.value === "yg-mail") {
                                                                setFirstConditionType("yg-mail")
                                                            } else {
                                                                setFirstConditionType("tickets")
                                                            }
                                                        }}>
                                                            <option value="" disabled selected>-- Select One --</option>
                                                            <option value="tickets">Tickets</option>
                                                            <option value="students">Students</option>
                                                            <option value="yg-mail">YG Mail</option>
                                                        </select>
                                                        {
                                                            firstConditionType === "tickets" ?
                                                                <select className='form-control condition_rule_0' required>
                                                                    <option value="" disabled selected>-- Select One --</option>
                                                                    <option value="created-by">Created By</option>
                                                                    <option value="raised-by">Raised By</option>
                                                                    <option value="subject">Subject</option>
                                                                </select>
                                                                :
                                                                firstConditionType === "students" ?
                                                                    <select className='form-control condition_rule_0' required>
                                                                        <option value="" disabled selected>-- Select One --</option>
                                                                        <option value="created-by">Intake</option>
                                                                        <option value="branch">Branch</option>
                                                                        <option value="student-email-id">Student Email Id</option>
                                                                        <option value="student-yg-id">Student YG Id</option>
                                                                    </select>
                                                                    :
                                                                    firstConditionType === "yg-mail" ?
                                                                        <select className='form-control condition_rule_0' required>
                                                                            <option value="" disabled selected>-- Select One --</option>
                                                                            <option value="created-by">Intake</option>
                                                                            <option value="branch">Branch</option>
                                                                            <option value="std-yg">std yg id</option>
                                                                            <option value="subject">subject</option>
                                                                        </select>
                                                                        :
                                                                        <select className='form-control condition_rule_0' required>
                                                                            <option value="" disabled selected>-- Select One --</option>
                                                                            <option value="created-by">Created By</option>
                                                                            <option value="raised-by">Raised By</option>
                                                                            <option value="subject">Subject</option>
                                                                        </select>
                                                        }

                                                        <select className='form-control condition_logic_0' required>
                                                            <option value="" disabled selected>-- Select One --</option>
                                                            <option value="contains">Contains</option>
                                                            <option value="not-contains">Not Contains</option>
                                                            <option value="exact-match">Exact Match</option>
                                                            <option value="in">In</option>
                                                            <option value="not-in">Not In</option>
                                                        </select>
                                                    </div>
                                                    <input type="text" className='w-100 form-control condition_value_0' placeholder='Condition Value' />
                                                </div>
                                            </div>
                                            <button type='submit' style={{ fontWeight: "500" }} className='customeButtonGradient border-0 py-1 rounded-pill d-flex align-items-center shadow-sm mt-3'><AddIcon /> Add new condition</button>
                                        </form>,
                                },
                                {
                                    title: 'Action',
                                    description:
                                        <form className='d-flex flex-column align-items-start w-100' style={{ paddingRight: "20px", position: "relative" }} onSubmit={(e) => { addNewAction(e, "actionFrame", "action") }}>
                                            <div className='d-flex flex-column align-items-start gap-2 w-100' id="actionFrame">
                                                <div className='alert alert-secondary shadow-sm d-flex flex-column gap-3 w-100 m-0 actionItem' id='action_0'>
                                                    <div className='w-100 d-flex gap-3  flex-wrap flex-lg-nowrap'>
                                                        <select className={`form-control action_select_mainCategory_0 w-100`} required onChange={(e) => { setSelectedActionType(e.target.value); }}>
                                                            <option value="" disabled selected>-- Select One --</option>
                                                            <option value="ticket-status">Ticket Status</option>
                                                            <option value="ticket-assigned-to">Ticket Assigned to</option>
                                                            <option value="ticket-priority-as">Ticket Priority as</option>
                                                        </select>
                                                        {
                                                            selectedActionType === "ticket-status" ?
                                                                <select className='form-control action_select_subCategory_0 w-100' required>
                                                                    <option value="" disabled selected>--Select User--</option>
                                                                    {
                                                                        [
                                                                            { "label": "Open", "value": "open" },
                                                                            { "label": "Re-Open", "value": "re-open" },
                                                                            { "label": "Closed", "value": "closed" },
                                                                            { "label": "In-Process", "value": "in-process" },
                                                                            { "label": "Invalid", "value": "invalid" }
                                                                        ].map((user, key) => {
                                                                            return (
                                                                                <option value={user.value} key={key}>{user.label}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>

                                                                :
                                                                selectedActionType === "ticket-priority-as" ?
                                                                    <select className='form-control action_select_subCategory_0 w-100' required>
                                                                        <option disabled selected>--Select User--</option>
                                                                        {
                                                                            [
                                                                                { "label": "Low", "value": "low" },
                                                                                { "label": "Medium", "value": "medium" },
                                                                                { "label": "High", "value": "high" },
                                                                            ].map((user, key) => {
                                                                                return (
                                                                                    <option value={user.value} key={key}>{user.label}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    :
                                                                    selectedActionType === "ticket-assigned-to" ?
                                                                        <select className='form-control action_select_subCategory_0 w-100' required>
                                                                            <option disabled selected>--Select User--</option>
                                                                            {
                                                                                userOptions.map((user, key) => {
                                                                                    return (
                                                                                        <option value={user.value} key={key}>{user.label}</option>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </select>
                                                                        :
                                                                        ""
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <button type='submit' style={{ fontWeight: "500" }} className='customeButtonGradient border-0 py-1 rounded-pill d-flex align-items-center shadow-sm mt-3'><AddIcon /> Add new Action</button>
                                        </form>,
                                },
                            ]}
                        />


                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-sm btn-success rounded-pill px-3 py-1' onClick={(e) => { saveRule() }}>Save Rule</button>
                </Modal.Footer>

            </Modal>
        </>
    )
}

export default TAR